module.exports = __webpack_public_path__ + "img/auction-1.bcc6e337.png";